module.exports = " <div class=\"message-box animated\" :transition=transition transition-mode=in-out> <article :class=\"['message', type ? `is-${type}` : '']\"> <div class=message-header> <button class=\"delete touchable\" @click=close() v-if=showCloseButton></button> <span class=icon v-if=icon> <i :class=\"['fa', `fa-${icon}`]\"></i> </span> {{ title }} </div> <div class=message-body v-if=message>{{ message }}</div> </article> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-message/src/Message.vue
// module id = 922
// module chunks = 2